<template lang="pug">

table.ui.fixed.table

    thead
        tr
            th.one.wide &nbsp;
            th Auflage
            th Stückpreis
            th Versandkosten
            th Gesamtpreis
            th.one.wide &nbsp;

    tbody
        tr(
            is="row"
            v-for="priceModel in priceModels"
            v-bind:key="priceModel.id"
            v-bind:is-best-price="isBestPrice(priceModel)"
            v-bind:hide-actions="isAnyPriceAccepted"
            v-bind:price-model="priceModel"
            v-bind:product-model="productModel"
        )


</template>

<script>
    import * as R from 'ramda'
    import { is_best_price } from '@/utils/price'
    import Row from './table/Row'

    export default {

        components: { Row },

        computed: {

            isAnyPriceAccepted() {
                return R.any(R.propEq('status', 'ACCEPTED'), this.priceModels)
            },

        },

        methods: {

            isBestPrice(priceModel) {
                return is_best_price(priceModel, this.priceModels)
            },

        },

        props: {

            priceModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            }

        }

    }

</script>
